module.exports = __webpack_public_path__ + "img/343f673.png";